import { C } from "../theme";

export function UsageChart({ bars }: { bars: number[] }) {
  const peak = Math.max(1, ...bars);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        gap: 5,
        height: 120,
        marginBottom: 16,
      }}
    >
      {bars.map((v, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            height: "100%",
          }}
        >
          <div
            style={{
              height: `${Math.round((v / peak) * 100)}%`,
              background:
                i === bars.length - 1 ? C.ac : "rgba(54,224,127,.32)",
              borderRadius: "2px 2px 0 0",
              boxShadow:
                i === bars.length - 1 ? "0 0 8px rgba(54,224,127,.4)" : "none",
            }}
          />
        </div>
      ))}
    </div>
  );
}
